import { render, staticRenderFns } from "./courseDetail.vue?vue&type=template&id=5862be08&scoped=true"
import script from "./courseDetail.vue?vue&type=script&lang=js"
export * from "./courseDetail.vue?vue&type=script&lang=js"
import style0 from "./courseDetail.vue?vue&type=style&index=0&id=5862be08&prod&lang=less&scoped=true"
import style1 from "./courseDetail.vue?vue&type=style&index=1&id=5862be08&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5862be08",
  null
  
)

export default component.exports